<template>
    <div id="frm_register" v-if="api">
        <form action="" method="post" class="frm_register form-horizontal" @submit.prevent="register_member" v-if="stepActive==='1'">
            <div class="form-group">
                <label class="col-sm-3 control-label">Họ và tên <strong>*</strong></label>
                <div class="col-sm-9">
                    <input type="text" name="name" class="form-control" value="" required  v-model="member.name" autocomplete="off">
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-3 control-label">Giới tính</label>
                <div class="col-sm-9">
                    <label class="radio-inline">
                        <input type="radio" name="gender" class="inlineRadio" value="1"  v-model="member.gender"> Nam
                    </label>
                    <label class="radio-inline">
                        <input type="radio" name="gender" class="inlineRadio" value="0"  v-model="member.gender"> Nữ
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-3 col-xs-12 control-label">Ngày sinh</label>
                <div class="col-sm-9">
                    <datetime type="date" format="yyyy-MM-dd" name="birthday" class="form-control" v-model="member.birthday" autocomplete="off"></datetime>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-3 control-label">Điện thoại <strong>*</strong></label>
                <div class="col-sm-9">
                    <input type="text" name="phone" class="form-control" value="" required v-model="member.phone" autocomplete="off" @change="formatNumberPhone"  v-mask="'###########'">
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-9 col-sm-offset-3">
                    <button type="submit" class="btn" v-bind:class="{'loading':loading}">Đăng ký</button>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-6">
                    <a href="http://m.me/suonmuoi/" class="btn btn-face">Đăng ký bằng Facebook</a>
                </div>
                <div class="col-sm-6">
                    <a href="https://zalo.me/1705536519471400695" class="btn btn-zalo">Đăng ký bằng Zalo</a>
                </div>
            </div>
        </form>
        <div class="message" v-if="stepActive==='2'" style="text-align: center;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Register',
        props:{
            stepActive: {
                type: String,
                default: "1"
            }
        },
        data () {
            return {
                api: this.$foodbookConfig.wpapi, //Api url
                member: {
                    birthday: null,
                    phone: null,
                    name: null,
                    gender: -1,
                },
                loading: false,
                validates: false,
            }
        },
        mounted() {
            let ref = document.referrer;
            if(this.stepActive === '2' && !ref){
                window.location.replace(this.$foodbookConfig.homepage);
            }
        },
        created(){

        },
        methods: {
            nextStep() {
                this.stepActive = parseInt(this.stepActive) + 1;
            },
            formatNumberPhone() {
                if (!this.member.phone) return false;
                let firstChar = this.member.phone.substring(0, 1);
                if (firstChar === '0') {
                    this.member.phone = '84' + this.member.phone.substring(1)
                }
            },
            register_member: function(event) {
                if (this.member.name
                    && this.member.phone
                    && this.member.birthday
                    && this.member.gender) {
                    //Check format
                    if (this.member.phone.length < 11) {
                        this.validates = true;
                        this.$toasted.show("Số điện thoại phải hơn 10 số", {
                            theme: "primary",
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                    if (this.member.phone.substring(0, 2) !== '84') {
                        this.validates = true;
                        this.$toasted.show("Số điện thoại không đúng (84xxxxxxx)", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                    //Tạo member
                    this.loading = true;
                    let $date = new Date(this.member.birthday);
                    let dateY = $date.getFullYear();
                    let dateM = ("0" + ($date.getMonth() + 1)).slice(-2);
                    let dateD = ("0" + $date.getDate()).slice(-2);
                    this.member.birthday = dateD + '/' + dateM + '/' + dateY;
                    this.$http.post(this.api + '/member', this.member, {method: 'POST'}).then(response => {
                        this.loading = false;
                        if (!response) {
                            this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else {
                            if (!response.body.error) {
                                this.$toasted.show("Đăng ký thành viên thành công!", {
                                    position: "top-center",
                                    duration: 5000,
                                    type: 'success'
                                });
                                //this.nextStep();
                                window.location.href = this.$foodbookConfig.registerpage;
                            } else {
                                //this.$toasted.show(response.body.error.message, {
                                this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                                    position: "top-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                        }
                    }, response => {
                        this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        this.loading = false;
                    });
                    this.validates = false;
                } else {
                    this.validates = true;
                    this.$toasted.show("Vui lòng điền đầy đủ thông tin", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Register.vue